<div class="page--component">
<ion-content [style.--background]="background ? background : 'inherit'">
    <div class="page--header">
        <ng-content select="page-template-header"></ng-content>
    </div>
    <div class="page--content">
        <ng-content select="page-template-content"></ng-content>
    </div>
    <div class="page--footer">
        <ng-content select="page-template-footer"></ng-content>
    </div>
</ion-content>
</div>